import {JournalEntryModel} from '../types';
import {useGet} from './../useHttpHooks';
import toQuery from '../../lib/toQuery.ts';

export type GetJournalEntriesQuery = {
    mixId: string;
    skipDate: string | null;
    take: number;
};

const useGetJournalEntries = (request: GetJournalEntriesQuery) =>
    useGet<JournalEntryModel[]>(
        `/api/journal/get-journal-entries?${toQuery(request)}`,
        {errorMessage: 'GET api/journal/get-journal-entries failed'}
    );

export default useGetJournalEntries;
